import React, { useState } from "react";

import BrandModal from "@/common/Modal/BrandModal";
import { Device } from "@/features/devices/types";
import {
  isMusicServiceSuspensionUiEnabled,
  resolveMusicServiceContext,
} from "@/features/devices/musicServiceApi";
import MusicServiceSuspensionPanel from "./MusicServiceSuspensionPanel";
import styles from "./MusicServiceSuspensionModal.module.scss";

export const MUSIC_SERVICE_MODAL_WIDTH = 960;

/** Viewport-safe body height: leave room for ant modal chrome + title so footer stays visible. */
export const MUSIC_SERVICE_MODAL_BODY_MAX_HEIGHT =
  "min(calc(100vh - 168px), 560px)";

const MusicServicePaymentManage: React.FC<{
  device: Device;
  onEntitlementChanged?: () => void | Promise<unknown>;
}> = ({ device, onEntitlementChanged }) => {
  const [open, setOpen] = useState(false);
  if (!isMusicServiceSuspensionUiEnabled()) return null;
  const context = resolveMusicServiceContext(device);

  return (
    <>
      <button
        type="button"
        className={styles.manageIcon}
        data-testid="music-service-manage"
        title="Manage Music Service"
        aria-label="Manage music service suspension"
        onClick={(event) => {
          event.stopPropagation();
          setOpen(true);
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            event.stopPropagation();
            setOpen(true);
          }
        }}
      >
        <i className="bi bi-credit-card" aria-hidden="true" />
      </button>
      <BrandModal
        title={
          <span className={styles.modalTitle} data-testid="music-service-modal-title">
            <i className={`bi bi-music-note-beamed ${styles.modalTitleIcon}`} aria-hidden="true" />
            <span>Music Service Suspension</span>
          </span>
        }
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={MUSIC_SERVICE_MODAL_WIDTH}
        centered
        destroyOnHidden
        maskClosable
        styles={{
          content: {
            maxWidth: "min(960px, calc(100vw - 48px))",
            maxHeight: "calc(100vh - 32px)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          },
          body: {
            flex: "1 1 auto",
            minHeight: 0,
            maxHeight: MUSIC_SERVICE_MODAL_BODY_MAX_HEIGHT,
            overflowX: "hidden",
            overflowY: "hidden",
            padding: "4px 20px 12px",
            display: "flex",
            flexDirection: "column",
          },
        }}
        data-testid="music-service-suspension-modal"
      >
        <div
          className={styles.modalBody}
          data-testid="music-service-suspension-modal-body"
          onClick={(event) => event.stopPropagation()}
        >
          <MusicServiceSuspensionPanel
            key={device.id}
            context={context}
            onClose={() => setOpen(false)}
            onEntitlementChanged={onEntitlementChanged}
          />
        </div>
      </BrandModal>
    </>
  );
};

export default MusicServicePaymentManage;
